let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6p3MK")).then(() => parcelRequire('6qIoF'));